<template>
  <h1 class="text-4xl sm:text-5xl mt-16 sm:mt-24 mb-14 font-bold"><slot /></h1>
</template>

<script>
export default {
  name: "Heading1",
};
</script>
